import { useState, useEffect } from "react"
import { DateGenerator } from "..";

const DetectNetwork = () => {
    const [ state, setState ] = useState({
        online: navigator.onLine,
    });

    useEffect(() => {

        const handleOnline = () => {
            // getServerDate()
            setState(prevState => ({
                ...prevState,
                online:true
            }))
        }
        const handleOffline = () => {
            setState(prevState => ({
                ...prevState,
                online:false
            }))
        }
        
        window.addEventListener("online", handleOnline);
        window.addEventListener("offline", handleOffline);

        return () => {
            window.removeEventListener("online", handleOnline);
            window.removeEventListener("offline", handleOffline);
        }
    }, [])

    return state;
}

export default DetectNetwork;